import moment from 'moment'
import { FIXED_DATE_MODE } from '../constants'

export const formatFixedDateDisplay = fixedDate => {
  const mode = fixedDate?.mode
  const value = fixedDate?.value
  if (value == null || value === '') return ''

  if (mode === FIXED_DATE_MODE.day) {
    const parsed = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true)
    return parsed.isValid() ? parsed.format('Do MMMM YYYY') : String(value)
  }
  if (mode === FIXED_DATE_MODE.dayOfYear) {
    return `day ${value} of year`
  }
  if (mode === FIXED_DATE_MODE.weekOfYear) {
    return `week ${value} of year`
  }
  return String(value)
}
